import { render, staticRenderFns } from "./ProposalPreviewModal.vue?vue&type=template&id=1ce85b56&scoped=true&"
import script from "./ProposalPreviewModal.vue?vue&type=script&lang=js&"
export * from "./ProposalPreviewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce85b56",
  null
  
)

export default component.exports